import React, { createContext, useContext, useState } from 'react';
import ShareLinkDialog from './ShareLinkDialog';

const ShareLinkDialogContext = createContext();
export const useShareLinkDialog = () => useContext(ShareLinkDialogContext);

function ShareLinkDialogProvider(props) {
    const { children } = props;

    const [ isShareLinkDialogOpen, setIsShareLinkDialogOpen ] = useState(false);
    const [ isDirectory, setIsDirectory ] = useState(false);
    const [ fileSystemNodePath, setFileSystemNodePath ] = useState([]);

    const open = (isDirectory, fileSystemNodePath) => {
        setIsDirectory(isDirectory);
        setFileSystemNodePath(fileSystemNodePath);
        setIsShareLinkDialogOpen(true);
    }

    return (
        <ShareLinkDialogContext.Provider value={{ open }}>
            {children}
            <ShareLinkDialog open={isShareLinkDialogOpen} isDirectory={isDirectory} fileSystemNodePath={fileSystemNodePath} handleCancel={() => {setIsShareLinkDialogOpen(false)}}/>
        </ShareLinkDialogContext.Provider>
    );
}
export default ShareLinkDialogProvider;